import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';

/**
 * Operational record DTO
 */
export abstract class OperationalRecordDto {
	subjectId!: number;
	subject!: AppSubjectEnum.RENTAL_AGREEMENT | AppSubjectEnum.VEHICLE_MAINTENANCE;
}
